/**
 * Fallback viewport for failed phase rendering.
 */

interface ErrorProps {
    message: string;
    onRetry?: () => void;
}

export const PhaseErrorState = ({ message = "The requested phase could not be initialized.", onRetry }: ErrorProps) => {

    return (
        <div className="w-full flex-grow flex flex-col items-center justify-center py-12 px-6 mb-3 text-center border-2 border-dashed border-slate-200 dark:border-slate-800 rounded-xl">
            {/* Warning Icon */}
            <div className="size-20 rounded-full bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor" className="size-12 text-red-500">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                </svg>
            </div>

            <h3 className="text-lg font-medium text-slate-900 dark:text-slate-100">
                Engine Render Failure
            </h3>

            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400 max-w-xs">
                {message}
            </p>

            {onRetry && (
                <button onClick={onRetry} className="mt-6 px-4 py-2 bg-slate-900 dark:bg-slate-100 text-white dark:text-slate-900 text-sm font-medium rounded-md hover:opacity-90 transition-opacity">
                    Attempt Re-initialization
                </button>
            )}
        </div>
    )
}